import { TPacketList, useGetLoraPackets } from 'api/packets/getLoraPacketList'
import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { RiRedPacketLine } from 'react-icons/ri'
import { useParams } from 'react-router-dom'
import { TDeviceType } from 'views/panel/Devices/RegisterDevice/api/registerDevice'
import { LoraPacketTable } from 'views/panel/Packets/LoraPacketList/components/LoraPacketTable'
import { SnmpPacketList } from 'views/panel/Packets/SnmpPacketList/components/SnmpPacketList'
import { QueryPaginated } from '..'
import { LoraGatewayPacketList } from './LoraGatewayPacketList'
import { MqttDevicePacketList } from './MqttDevicePacketList'
import { networkProviderIds } from 'views/panel/Devices/RegisterDevice/networkProviders'

export const LoraDevicePacketList = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const query = useGetLoraPackets({ deviceId })

  return (
    <>
      <QueryPaginated.Wrapper query={query}>
        <QueryPaginated.Data>
          {(data: TPacketList) => (
            <LoraPacketTable
              refetch={query.refetch}
              dataUpdatedAt={query.dataUpdatedAt}
              isFetching={query.isFetching}
              data={data.items}
            />
          )}
        </QueryPaginated.Data>
        <QueryPaginated.NoData
          icon={RiRedPacketLine}
          title={t('packet.noData')}
        />
      </QueryPaginated.Wrapper>
    </>
  )
}

const Unsupported = () => <div>Unsupported</div>

export const DevicePacketsMap: Record<TDeviceType, ReactNode> = {
  LoraDevice: <LoraDevicePacketList />,
  LoraGateway: <LoraGatewayPacketList />,
  SNMP: <SnmpPacketList />,
  MQTT: <Unsupported />,
  UnKnown: <Unsupported />,
}

export const DevicePacketList = ({
  deviceType,
  networkProviderId,
}: {
  deviceType: TDeviceType
  networkProviderId?: number
}): ReactElement => {
  if (networkProviderId === networkProviderIds.mqttBojki) {
    return <MqttDevicePacketList />
  }

  return <>{DevicePacketsMap[deviceType] ?? <Unsupported />}</>
}
